import { createContext, Dispatch, ReactNode, useContext, useReducer, useState, SetStateAction, useMemo } from 'react';
import { beneficiariesForm, PEPForm } from './beneficiariesForm';
import { reducer, PepReducer } from './reducer';
import { BeneficiariesActions, PepActions } from './action';

export const initialState = {
  surname: '',
  givenName: '',
  share: undefined,
  relationship: null,
  gender: null,
  birthDate: '',
  idNo: '',
  idType: null,
  birthCountry: null,
  residenceCountry: null,
  taxResidence: [],
  specifyRelationship: '',
  beneficiaryAction: 'noChange',
  role: '',
  id: '',
  relationshipDesc: '',
  relationshipDescTc: '',
  birthCountryDesc: '',
  birthCountryDescTc: '',
  residenceCountryDesc: '',
  residenceCountryDescTc: '',
  taxResidenceDesc: '',
  taxResidenceDescTc: '',
  genderDesc: '',
  genderDescTc: '',
  irrevocableFlag: false,
  // clientType: 'P',
};

// 定义 Context 类型
export interface BeneficiariesContextType {
  state: beneficiariesForm[];
  dispatch: Dispatch<BeneficiariesActions>;
  policyNC: string;
  setpolicyNC: (policyNC: string) => void;
  oldBeneficiariesList: beneficiariesForm[];
  setOldBeneficiariesList: Dispatch<SetStateAction<beneficiariesForm[]>>;
  pep: PEPForm;
  setPep: Dispatch<PepActions>;
  companyCodeNc: string;
  setCompanyCodeNc: (companyCodeNc: string) => void;
  uploadFlag: string;
  setUploadFlag: (companyCodeNc: string) => void;
  highRiskC: boolean;
  setHighRiskC: (highRiskC: boolean) => void;
  highRiskP: boolean;
  setHighRiskP: (highRiskC: boolean) => void;
}
export const BeneficiariesContext = createContext<BeneficiariesContextType>({
  state: [],
  dispatch: () => null,
  policyNC: '',
  setpolicyNC: () => {
    //
  },
  companyCodeNc: '',
  setCompanyCodeNc: () => {
    //
  },
  oldBeneficiariesList: [],
  setOldBeneficiariesList: () => null,
  pep: {
    isDeclaration: 'No',
    pepName: '',
    pepPosition: '',
    relevantPartyName: '',
    pepRelationship: '',
  },
  setPep: () => null,
  highRiskC: false,
  setHighRiskC: () => {
    //
  },
  highRiskP: false,
  setHighRiskP: () => {
    //
  },
  uploadFlag: '',
  setUploadFlag: () => {
    //
  },
});

// 创建自定义 Hook
export function useBeneficiaries() {
  return useContext(BeneficiariesContext);
}

// Provider 组件
export function BeneficiariesFormProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(reducer, []);
  const [uploadFlag, setUploadFlag] = useState('N');
  const [policyNC, setpolicyNC] = useState('');
  const [pep, setPep] = useReducer(PepReducer, {
    isDeclaration: 'No',
    pepName: '',
    pepPosition: '',
    relevantPartyName: '',
    pepRelationship: '',
  });
  const [companyCodeNc, setCompanyCodeNc] = useState('');
  const [highRiskC, setHighRiskC] = useState(false);
  const [highRiskP, setHighRiskP] = useState(false);
  const [oldBeneficiariesList, setOldBeneficiariesList] = useState<beneficiariesForm[]>([]);
  const contextValue = useMemo(
    () => ({
      state,
      dispatch,
      policyNC,
      setpolicyNC,
      oldBeneficiariesList,
      setOldBeneficiariesList,
      pep,
      setPep,
      companyCodeNc,
      setCompanyCodeNc,
      uploadFlag,
      setUploadFlag,
      highRiskC,
      setHighRiskC,
      highRiskP,
      setHighRiskP,
    }),
    [state, policyNC, oldBeneficiariesList, pep, companyCodeNc, uploadFlag, highRiskC, highRiskP],
  ); //
  return <BeneficiariesContext.Provider value={contextValue}>{children}</BeneficiariesContext.Provider>;
}
